import { CASES } from './constants';

export const updateDateMath = (payload) => {
    return { type: CASES.UPDATE_DATE_MATH, payload };
};

export const updateMacroTriggers = ({ key, data }) => {
    return {
        type: CASES.UPDATE_MACRO_TRIGGERS,
        payload: { key, data },
    };
};

export const updateDateMathSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_DATE_MATH_SEARCH_FORM,
        payload: { key, data },
    };
};
export const clearDateMathMacros = () => {
    return { type: CASES.CLEAR_DATE_MATH_MACROS, payload: {} };
};

export const clearDateMath = () => {
    return { type: CASES.CLEAR_DATE_MATH, payload: {} };
};
